import { Container, Row } from "react-bootstrap";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';

export const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <Row className="align-item-center">
                    <div className="social-icon">
                        <a href="https://www.linkedin.com/in/liora-metivier/"><img src={navIcon1} alt="" /></a>
                        <a href="mailto:metivierliora@gmail.com"><img src={navIcon2} alt="" /></a>
                    </div>
                </Row>
            </Container>
        </footer>
    )
}